import React, {Component, ReactElement} from 'react'
import {SessionStorageHelper} from '../../../SessionStorageHelper'
import {Nullable} from '../../../app/TypeHelpers'
import {createResidentPage, ResidentPagePropsSet} from '../../../components/shared/hoc/createResidentPage'
import {Location} from 'react-router-dom'


const KEY_SENI_TYPE = 'seniType'
const KEY_SENI_URL = 'seniUrl'
const SENI_TYPE_MYPAGE = 'seniTypeMypage'
const SENI_TYPE_CONDOMINIUM_SELECTION = 'seniTypeCondominiumSelection'
const SENI_TYPE_OTHER = 'seniTypeOther'

interface Props {
    location: Location
}

class NatResidentLoginRedirectPage extends Component<Props & ResidentPagePropsSet> {

    seniUrl: Nullable<string>
    seniType: Nullable<string>

    constructor(props: Readonly<Props & ResidentPagePropsSet>) {
        super(props)

        this.seniUrl = SessionStorageHelper.getStringItemOrNull(KEY_SENI_URL)
        this.seniType = SessionStorageHelper.getStringItemOrNull(KEY_SENI_TYPE)

        if (this.seniType === SENI_TYPE_MYPAGE) {
            // マイページへ遷移
            this.props.navigate(
                '/resident/mypage')
        } else if (this.seniType === SENI_TYPE_OTHER && this.seniUrl) {

            this.props.navigate(this.seniUrl)

        } else if (this.seniType === SENI_TYPE_CONDOMINIUM_SELECTION) {
            if (this.seniUrl) {
                this.props.navigate(
                    '/resident/condominiumSelect',
                    {state: {seniurl: this.seniUrl}})
            } else {
                this.props.navigate('/resident/condominiumSelect')
            }

        } else {
            this.props.navigate('/resident/login')
        }
    }

    render(): Nullable<ReactElement> {
        return (
            <>
            </>
        )
    }
}

export default createResidentPage(NatResidentLoginRedirectPage)
